Auth = require 'db/auth'
Controller = require 'controller'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/card_detail_watch_menu'
trackUe = require 'debug/trackUe'
_ = require 'underscore'

module.exports = class CardDetailMoreMenuView extends View
  viewTitleKey: 'watch card'

  events:
    'click .js-sign-up-on-watch-menu': ->
      trackUe(
        "watch menu", "navigates", "to sign up page", "", "", "by clicking sign up button",
        { cardid: @model.id, boardid: @model.getBoard().id }
      )
    'click .js-log-in-on-watch-menu': ->
      trackUe(
        "watch menu", "navigates", "to log in page", "", "", "by clicking log in button",
        { cardid: @model.id, boardid: @model.getBoard().id }
      )

  render: ->
    cardUrl = encodeURIComponent(Controller.getCardUrl(@model))

    data =
      signupUrl: "/signup?returnUrl=#{ cardUrl }"
      loginUrl: "/login?returnUrl=#{ cardUrl }"

    @$el.html template(data)

    @



// WEBPACK FOOTER //
// ./app/scripts/views/card/card-detail-watch-menu-view.coffee